import { Stack } from '@mantine/core'
import LabeledTitle from '../../../components/LabeledTitle'
import ReportItem from '../ReportItem'

interface RelatedPartyBankFailureFraudProps {
  data: any
}

export default function RelatedPartyBankFailureFraud({ data }: RelatedPartyBankFailureFraudProps) {
  return (
    <Stack>
      <LabeledTitle title={'关联人银行失联欺诈行为检测'} />
      <ReportItem
        name={'是否有银行失联欺诈行为'}
        value={data?.aals_00001 === 1 ? '是' : '否'}
        isNormal={data?.aals_00001 !== 1}
      />
    </Stack>
  )
}
